import React, { useState } from 'react';
import axios from 'axios';
import {
  Container,
  TextField,
  Button,
  Typography,
  Grid,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper
} from '@mui/material';
import AirShipment from './Shipments/AirShipment';
import OceanShipment from './Shipments/OceanShipment';
import RoadShipment from './Shipments/RoadShipment';
import shipImage from './Shipments/Images/International.png';
import planeImage from './Shipments/Images/Domestic-.png';
import truckImage from './Shipments/Images/Full-Truck.png';
import { Footer } from '../../components/Footer';
import ziplogyxLogo from '../../assets/images/Ziplogyx_inverted_logo_final.png';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Tracking = () => {
  const [shipmentType, setShipmentType] = useState('ocean');
  const [trackingNumber, setTrackingNumber] = useState('');
  const [shipmentData, setShipmentData] = useState(null);
  const [error, setError] = useState('');
  const [step, setStep] = useState(1);

  const handleSearch = async () => {
    setError('');
    setShipmentData(null);

    try {
      const response = await axios.get(BACKEND_URL, {
        params: { shipmentType, trackingNumber },
      });
      setShipmentData(response.data[0]);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error || 'Failed to fetch shipment data. Please try again.');
    }
  };

  const handleBack = () => {
    setStep(1);
    setTrackingNumber('');
    setShipmentData(null);
    setError('');
  };

  return (
    <Container maxWidth="lg" sx={{ py: 15, textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
      {step === 1 && (
        <>
          <Typography variant="h4" gutterBottom>
            Select Shipment Type
          </Typography>
          <Grid container spacing={4} justifyContent="center">
            <Grid item>
              <IconButton onClick={() => { setShipmentType('air'); setStep(2); }}>
                <img src={planeImage} alt="Plane" style={{ width: 200, height: 200 }} />
              </IconButton>
              <Typography>Air</Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={() => { setShipmentType('ocean'); setStep(2); }}>
                <img src={shipImage} alt="Ship" style={{ width: 200, height: 200 }} />
              </IconButton>
              <Typography>Ocean</Typography>
            </Grid>
            <Grid item>
              <IconButton onClick={() => { setShipmentType('road'); setStep(2); }}>
                <img src={truckImage} alt="Truck" style={{ width: 200, height: 200 }} />
              </IconButton>
              <Typography>Road</Typography>
            </Grid>
          </Grid>

          
        </>
      )}

      {step === 2 && (
        <>
          <Typography variant="h5" gutterBottom>
            Enter Tracking ID
          </Typography>
          <TextField
            label="Tracking ID"
            value={trackingNumber}
            onChange={(e) => setTrackingNumber(e.target.value)}
            fullWidth
            sx={{ my: 2, maxWidth: 400 }}
          />
          <Button variant="contained" onClick={handleSearch} fullWidth sx={{ maxWidth: 400 }}>
            Search
          </Button>
          <Button variant="text" sx={{ mt: 2 }} onClick={handleBack}>
            Back
          </Button>
          
        </>
        

        
      )}

      {error && <Typography color="error" mt={2}>{error}</Typography>}

      {shipmentData && (
        <TableContainer component={Paper} sx={{ mt: 4, width: '100%' }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell colSpan={2} align="center" sx={{ fontWeight: 'bold', fontSize: 18 }}>Shipment Details</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell colSpan={2} align="center">
                  {shipmentType === 'air' && <AirShipment shipmentData={shipmentData} />}
                  {shipmentType === 'ocean' && <OceanShipment shipmentData={shipmentData} />}
                  {shipmentType === 'road' && <RoadShipment shipmentData={shipmentData} />}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell width="50%">
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold' }}>Field 1</TableCell>
                          <TableCell>Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {/* Add relevant data rows here */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TableCell>
                <TableCell width="50%">
                  <TableContainer component={Paper}>
                    <Table>
                      <TableHead>
                        <TableRow>
                          <TableCell sx={{ fontWeight: 'bold' }}>Field 2</TableCell>
                          <TableCell>Value</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {/* Add relevant data rows here */}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      
      )}
      
    </Container>

  );
};

export default Tracking;
